import Axios from 'axios';


export default Axios.create({
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    withCredentials: true,
});



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/util/service/index.js